import { getInitCommentListPage } from "@/apis/dp/service";
import { ErrorTryAgain } from "@/components/error";
import LoadingIcon from "@/components/loading";
import UKLoadingIcon, { CIRCLE_COLOR_MAP } from "@/components/UKLoadingIcon";
import UKToast from "@/components/UKToast";
import { useTranslation } from "@/i18n/client";
import { EXPOSURE_RECORD as REVIEW_LIST_EXPOSURE_RECORD } from "@/tracks/25338";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import React, { useState } from "react";
import CommentItem from "./commentItem";
import ScoreRating from "./scoreRating";
import {sendClickTrack} from '@/tracks/25217';

export default function AllCommentList({ data, skuId, reviewFilterFn, reviewType, isLoading, isError }: any) {
  const { star, commentCount, tagList, details: { data: lists, maxPage } = {}, starShow } = data || {};
  const [selectFilter, setSelectFilter] = React.useState<any>(0); // 筛选
  const { t } = useTranslation();

  const pageSize = 10;
  const [commentData, setCommentData] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isCommentLoading, setIsCommentLoading] = useState(false);

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const target = event.currentTarget;
    if (target.scrollTop + target.clientHeight >= target.scrollHeight) {
      handleCommentLoading();
    }
  };

  const handleCommentLoading = async () => {
    if (currentPage >= maxPage || isCommentLoading) {
      return;
    }
    setIsCommentLoading(true);
    await fetchCommentList();
    setIsCommentLoading(false);
  };

  const fetchCommentList = async () => {
    const curPage = currentPage + 1;
    const res = await getInitCommentListPage({
      skuId,
      pageSize,
      currentPage: curPage,
      topIdList:''
    });
    if (res && res.code == "200") {
      const {
        details: { data: dataList = [] },
      } = res.data || {};
      const myData = [...(commentData || lists), ...dataList];
      setCommentData(myData);
      setCurrentPage(curPage);
    } else {
      UKToast.show({
        content: res?.msg || t("common.message.backLater"),
        icon: "warning",
      });
    }
  };

  // 筛选
  const handleReviewFilterChange = (event: SelectChangeEvent) => {
    setSelectFilter(Number(event.target.value));
    reviewFilterFn?.(Number(event.target.value));
  };

  const handlePictureVideoClick = () => {
    reviewFilterFn?.(4);
  };

  const filterStyle = {
    width: "158px",
    height: "32px",
    borderRadius: "4px",
    fontSize: "14px",
    boxShadow: "none",
    textTransform: "none",
    color: "#1a1a1a",
    background: "#F5F5F5",
    border: "1px solid #F5F5F5",
    "&:hover": {
      background: "#FFF3F4",
      border: "1px solid #CC0C1C",
      color: "#CC0C1C",
    },
  };
 
  return (
    <div className="review-list-all" >
     
      {/* 评分 */}
      <div className="review-list-header">
        {/* 去掉All from verified purchases */}
        {/* <ScoreRating
          value={star}
          starShow={starShow}
          extra={
            <span className="score-extra">
              {!!commentCount && (
                <>
                  <i className="verified-icon" />
                  {t("review.reviewPlaceholder")}
                </>
              )}
            </span>
          }
        /> */}
        {(commentData || lists)?.length > 0 ? 
        <>
        <ScoreRating
          value={star}
          starShow={starShow}
          />
          <span className="all-Reviews-info">({commentCount} {t("review.reviewTitle")})</span>
        </>
         :null
          }
      </div>
      {/* todo: 切换 active */}
      <div className="review-list-tag-layer">
        {tagList?.map((tag: any, index: number) => (
          <div key={index}>
            {tag.tag} {tag.num > 0 ? `(${tag.num})` : ""}
          </div>
        ))}
      </div>
      {/* 筛选 */}
      {false && (
        <div className="reviewListFilter" style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
          {reviewType != "pictureVideo" && (
            <Select
              id="select-small"
              label="Default"
              value={selectFilter}
              onChange={handleReviewFilterChange}
              sx={{
                ...filterStyle,
                marginRight: "10px",
                "& hover": {
                  "& .MuiSvgIcon-root": {
                    color: "#CC0C1C",
                  },
                },
                "& fieldset": {
                  display: "none",
                },
              }}
            >
              <MenuItem value={0}>{t("allCommentList.menu1")}</MenuItem>
              <MenuItem value={1}>{t("allCommentList.menu2")}</MenuItem>
              <MenuItem value={2}>{t("allCommentList.menu3")}</MenuItem>
            </Select>
          )}
          <Button
            variant="outlined"
            onClick={handlePictureVideoClick}
            sx={{
              ...filterStyle,
            }}
          >
            {`${t("allCommentList.buttontext")} `}({(commentData || lists)?.length})
          </Button>
        </div>
      )}
      {/* 错误 */}
      {isError && (
        <div style={{ width: "100%", height: "500px" }}>
          <ErrorTryAgain
            className="player-error"
            onEmit={() => {
              if (reviewType != "pictureVideo") {
                reviewFilterFn?.(4);
                return;
              }
              reviewFilterFn?.(selectFilter);
            }}
          />
        </div>
      )}
      {/* 加载中 */}
      {isLoading && (
        <div style={{ width: "100%", minHeight: "min(600px, calc(100vh - 212px))", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <LoadingIcon className="player-loading" />
        </div>
      )}
      {/*全部评价*/}
      {!isLoading && !isError && (
        <div className="report-reason-wrapper" 
        exptag={'exp|' + REVIEW_LIST_EXPOSURE_RECORD.Productdetail_Comment_Expo}
        data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
        data-exptag-json-param={JSON.stringify({
          skuid:skuId,
          mainskuid:skuId
        })}>
          <div onScroll={handleScroll} className="review-list-wrapper" style={{ maxHeight: "min(600px, calc(100vh - 212px))", overflowY: "auto" }}>
            {(commentData || lists)?.length > 0 ? (
              (commentData || lists)?.map((item: any, key: number) => {
                const {
                  star, // 评分
                  content, // 评论内容
                  userPin, // 用户pin
                  commentId, // 评论id
                  userImage, // 用户头像
                  usefulNum, // 有用数
                  commentSku, // 评论sku
                  commentNum, // 评论数
                  commentDate, // 评论时间
                  propertyExt, // 属性扩展
                  userNickName, // 用户昵称
                  targetReplyId, // 目标回复id
                  anonymousFlag, // 是否匿名
                  currentIsUseful, // 当前用户是否有用
                  parentReplyId = 0, // 父回复id
                  currentUserOperation, // 当前用户操作
                  videoList = [], // 视频列表
                  replyList = [], // 回复列表
                  imageList = [], // 图片列表
                  orderId
                } = item;
                const commentOpts = {
                  skuId, // skuId
                  commentId, // 评论id
                  usefulNum, // 有用数
                  commentNum, // 评论数
                  currentIsUseful, // 当前用户是否有用
                  anonymousFlag, // 是否匿名
                  currentUserOperation, // 当前用户操作
                  orderId,
                  commentStar: item.star, //8.30评价星级
                  verifiedPurchase: item.verifiedPurchase, //8.30购买标识
                  commentSource: item.commentSource, //8.30评价来源
                };
                const comment = {
                  star, // 评分
                  skuId, // skuId
                  content, // 评论内容
                  replyList, // 回复列表
                  userImage, // 用户头像
                  imageList, // 图片列表
                  videoList, // 视频列表
                  commentSku, // 评论sku
                  commentDate, // 评论时间
                  propertyExt, // 属性扩展
                  userNickName, // 用户昵称
                };
                const reportReqParams = {
                  commentId, // 评论id
                  targetReplyId, // 目标回复id
                  parentReplyId, // 父回复id
                  anonymousFlag, // 是否匿名
                  toPin: userPin, // 目标用户pin
                  toContent: content, // 目标评论内容
                  currentUserOperation, // 当前用户操作
                };
                const track={
                  mainskuid:skuId,
                  skuId:skuId,
                  commentId:commentId,
                  pageType:'reviewList'
                }
                return (
                  <div
                    className="reviews-item-block"
                    exptag={"exp|" + REVIEW_LIST_EXPOSURE_RECORD.Productdetail_Comment_Card_Expo}
                    data-exptag-json-param={JSON.stringify({
                      skuId: `${commentOpts?.skuId || "-100"}`,
                      commentId: `${commentOpts?.commentId || "-100"}`,
                      index: key,
                    })}
                    data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
                    key={key}
                  >
                    <CommentItem
                      showReplyList // 是否显示回复列表
                      isShowScoreStar // 是否显示评分星星
                      showCommentMedia // 是否显示评论媒体
                      isLimitReplyCount // 是否限制回复数量
                      comment={comment} // 评论
                      limitReplyCount={1} // 限制回复数量
                      commentOpts={commentOpts} // 评论选项
                      reportReqParams={reportReqParams} // 举报请求参数
                      showMoreReplyList={commentNum > 1} // 是否显示更多回复列表
                      trackData={track} 
                    />
                  </div>
                );
              })
            ) : (
              <div style={{ width: "100%", height: "500px" }}>
                <ErrorTryAgain
                  className="player-error"
                  errorMessage="No data available at the moment, please try again"
                  onEmit={() => reviewFilterFn?.(selectFilter)}
                />
              </div>
            )}
            {isCommentLoading && (
              <div className="loading">
                <UKLoadingIcon className="loading-icon" type={CIRCLE_COLOR_MAP.BLACK} />
              </div>
            )}
            {/* 当前最后数据文案 */}
            {currentPage >= maxPage && (
              <div style={{ width: "100%", height: "55px", lineHeight: "55px", textAlign: "center", color: "#C2C4CC", fontSize: "14px" }}>
                {t("dp.commentSection.end")}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
